<template>
  <div class="container">
    <h1>🎟️ Ticket Booking System</h1>

    <!-- Category Selection -->
    <h2>Select Ticket Type</h2>
    <div class="category-cards">
      <div
        v-for="cat in categories"
        :key="cat.name"
        :class="['card', { selected: selectedCategory === cat.name }]"
        @click="selectCategory(cat.name)"
      >
        <span class="icon">{{ cat.icon }}</span>
        <h4>{{ cat.name }}</h4>
      </div>
    </div>

    <!-- Sub-options -->
    <section v-if="selectedCategory" class="sub-options">
      <h3>Select {{ selectedCategory }} Option:</h3>
      <div class="sub-list">
        <div
          v-for="item in subOptions[selectedCategory]"
          :key="item.name"
          :class="['sub-card', { selected: selectedItem?.name === item.name }]"
          @click="selectedItem = item"
        >
          <strong>{{ item.name }}</strong>
          <p v-if="item.location">📍 {{ item.location }}</p>
          <p v-if="item.route">🛣️ {{ item.route }}</p>
        </div>
      </div>
    </section>

    <!-- Booking Form -->
    <section v-if="selectedItem" class="form-section">
      <h2>Book Ticket for {{ selectedItem.name }}</h2>

      <label>Date:</label>
      <input type="date" v-model="form.date" />

      <label>Tickets:</label>
      <input type="number" v-model="form.tickets" min="1" />

      <label>Name:</label>
      <input type="text" v-model="form.name" />

      <label>Email:</label>
      <input type="email" v-model="form.email" />

      <button @click="submitBooking">Book Now</button>

      <div v-if="confirmation" class="confirmation">
        <h3>✅ Booking Confirmed!</h3>
        <p>{{ confirmation }}</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "TicketBooking",
  data() {
    return {
      selectedCategory: null,
      selectedItem: null,
      categories: [
        { name: "Mall", icon: "🛍️" },
        { name: "Bus", icon: "🚌" },
        { name: "Movie", icon: "🎬" },
        { name: "Concert", icon: "🎤" },
      ],
      subOptions: {
        Mall: [
          { name: "SM Mall of Asia", location: "Pasay" },
          { name: "SM North EDSA", location: "Quezon City" },
          { name: "Robinsons Place Manila", location: "Manila" },
        ],
        Bus: [
          { name: "Victory Liner", route: "Cubao to Baguio" },
          { name: "Five Star", route: "Pasay to Dagupan" },
          { name: "Philtranco", route: "Manila to Legazpi" },
        ],
        Movie: [
          { name: "Inside Out 2" },
          { name: "Kung Fu Panda 4" },
          { name: "The Garfield Movie" },
        ],
        Concert: [
          { name: "SB19 World Tour" },
          { name: "Taylor Swift Eras Tour" },
          { name: "Sarah G Live!" },
        ],
      },
      form: {
        date: "",
        tickets: 1,
        name: "",
        email: "",
      },
      confirmation: ""
    };
  },
  methods: {
    selectCategory(cat) {
      this.selectedCategory = cat;
      this.selectedItem = null;
      this.confirmation = "";
      this.form = {
        date: "",
        tickets: 1,
        name: "",
        email: ""
      };
    },
    submitBooking() {
      if (this.form.date && this.form.name && this.form.email && this.selectedItem) {
        this.confirmation = `Successfully booked ${this.form.tickets} ticket(s) for "${this.selectedItem.name}" on ${this.form.date}.`;
      } else {
        this.confirmation = "❌ Please fill in all fields.";
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: auto;
  padding: 1rem;
  font-family: sans-serif;
}

h1, h2, h3 {
  text-align: center;
  margin-bottom: 0.5rem;
}

.category-cards, .sub-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.card, .sub-card {
  border: 1px solid #ccc;
  padding: 1rem;
  width: 150px;
  text-align: center;
  cursor: pointer;
  border-radius: 10px;
  transition: 0.3s ease;
}

.card:hover, .sub-card:hover {
  background-color: #f0f0f0;
}

.selected {
  border: 2px solid #007bff;
  background-color: #e6f0ff;
}

.form-section {
  margin-top: 2rem;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

label {
  display: block;
  margin-top: 1rem;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 0.5rem;
  margin-top: 0.2rem;
}

button {
  margin-top: 1rem;
  width: 100%;
  padding: 0.7rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.confirmation {
  margin-top: 1rem;
  background-color: #e6ffe6;
  padding: 1rem;
  border: 1px solid #33cc33;
  border-radius: 5px;
}
</style>
